import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'semantic-ui-react';
import { Resultados } from 'src/api';
import { NombrePersonal } from 'src/componentes';
import { imprimirFormaDePago } from '../../utilidades';

interface Props {
    recordatoriosDePago: Resultados<'recordatoriosDePago'>;
}

const TablaRecordatorios: React.FunctionComponent<Props> = props => {
    const { recordatoriosDePago } = props;

    return (
        <Table attached='bottom'>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell content='Nombre' width={5} />
                    <Table.HeaderCell content='Correo' width={4} />
                    <Table.HeaderCell content='Teléfono móvil' width={2} />
                    <Table.HeaderCell content='Forma de pago' width={2} />
                    <Table.HeaderCell content='Año' width={1} />
                    <Table.HeaderCell content='Día de pago' width={2} />
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {recordatoriosDePago.map((apoderado, index) => (
                    <Table.Row key={index} negative={apoderado.deudor}>
                        <Table.Cell selectable>
                            <Link to={`/cobranzas/plan/${apoderado.apoderadoId}`}>
                                <b>
                                    <NombrePersonal nombre={apoderado.nombre} />
                                </b>
                            </Link>
                        </Table.Cell>

                        <Table.Cell>
                            <a href={'mailto:' + apoderado.correo}>{apoderado.correo}</a>
                        </Table.Cell>
                        <Table.Cell content={'+569 ' + apoderado.telefono.numero} />
                        <Table.Cell content={imprimirFormaDePago(apoderado.formaDePago)} />
                        <Table.Cell content={apoderado.paraElAño} />
                        <Table.Cell content={apoderado.diaDePago} />
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );
};

export default TablaRecordatorios;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/RecordatoriosDePago/componentes/TablaRecordatorios.tsx